import { DeleteProjectResponse } from 'types/projects';
import { _post, requestType } from './_internal';

// TODO utilisé pour rafairchir la liste des projets dans le tableau admin mais le call backend ne réponds pas
export const getProjects = () => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_projets,
  });
};

// TODO le backend répond une erreur
export const createProject = (payload: any) => {
  return _post({ request_type: requestType.creation_d_un_projet, ...payload });
};

// TODO le backend répond une erreur
export const updateProject = (payload: any) => {
  return _post({
    request_type: requestType.modification_d_un_projet,
    ...payload,
  });
};

export const deleteProject = (payload: {
  project_id: string;
}): Promise<DeleteProjectResponse> => {
  return _post({
    request_type: requestType.supprimer_un_projet,
    project_id: payload.project_id,
  });
};

export const addImageToProject = (payload: {
  project_id: string;
  image: string;
}) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_projet,
    project_id: payload.project_id,
    image: payload.image,
  });
};

// TODO inutilisé, à supprimer
export const removeImageFromProject = (payload: { project_id: string }) => {
  return _post({
    request_type: requestType.ajouter_une_image_de_projet,
    project_id: payload.project_id,
  });
};
